export function removeQueryParam(paramName: string) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.delete(paramName);
    url.search = params.toString();
    window.history.replaceState(history.state, document.title, url);
}

export const OPERATOR_EXTERNAL_ID_HEADER = 'X-DG-Operator-External-Id';

export const OPERATOR_EXTERNAL_ID_QUERY_PARAM = 'dgOperatorExternalId';

export function urlWithOperatorExternalId(
    url: string,
    operatorExternalId: string,
) {
    const urlParsed = new URL(url, window.location.origin);

    urlParsed.searchParams.set(
        OPERATOR_EXTERNAL_ID_QUERY_PARAM,
        operatorExternalId,
    );

    return urlParsed.toString();
}
